module.exports = __webpack_public_path__ + "img/4X Travel-Uniglobe.b7fdee59.jpg";